import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import styles from "./styles.module.scss";

const CollapsibleSection = ({
  title,
  children,
  defaultOpen = true,
  isOpen,
  onToggle,
  bodyClassName,
  summary,
}: {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  isOpen?: boolean;
  onToggle?: () => void;
  bodyClassName?: string;
  /** Treść pokazywana w belce tytułowej tylko po zwinięciu sekcji. */
  summary?: React.ReactNode;
}) => {
  const [internalOpen, setInternalOpen] = useState(defaultOpen);
  const controlled = isOpen !== undefined && onToggle !== undefined;
  const open = controlled ? isOpen : internalOpen;
  const handleToggle = controlled ? onToggle : () => setInternalOpen((v) => !v);

  return (
    <div className={styles.section}>
      <button
        type="button"
        className={styles.sectionToggle}
        onClick={handleToggle}
      >
        <span className={styles.sectionTitle}>{title}</span>
        <span className={styles.sectionToggleRight}>
          {!open && summary}
          <FontAwesomeIcon
            icon={open ? faChevronUp : faChevronDown}
            className={styles.sectionChevron}
          />
        </span>
      </button>
      {open && (
        <div
          className={`${styles.sectionBody}${bodyClassName ? ` ${bodyClassName}` : ""}`}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
